import { useContext, useEffect, useState } from "react";
import ActionsPerformanceMetricsChartContext from "../../../../../../../contexts/actionsPerformanceMetricsChartContext";
import Select from "../../../../../../../shared/components/select/Select";
import { CardContent } from "../../../../../../../shared/components/card/Card";
import MetricsChart from "./MetricsChart";
import MetricsChartByDimension from "./MetricsChartByDimension";

const MetricsChartContainer = ({
  params,
  groupedMetricsChartData,
  dateRange,
  metricsSelectables,
  dimensionsSelectables,
  onGroupingDimensionChange,
}) => {
  const context = useContext(ActionsPerformanceMetricsChartContext);
  const [selectedMetric, setSelectedMetric] = useState(context.selectedMetric);
  const [selectedGroupingDimension, setSelectedGroupingDimension] = useState(
    context.selectedGroupingDimension,
  );
  const [displayGroupedChart, setDisplayGroupedChart] = useState(false);

  const onValueChangeHandler = (value) => {
    const newSelectedMetric = metricsSelectables.filter(
      (metric) => metric.value === value,
    )[0];
    setSelectedMetric(newSelectedMetric);
    context.setSelectedMetric(newSelectedMetric);
    onGroupingDimensionChange(selectedGroupingDimension, value);
  };

  const onGroupingDimensionChangeHandler = (value) => {
    setSelectedGroupingDimension(value);
    context.setSelectedGroupingDimension(value);
    onGroupingDimensionChange(value, selectedMetric.value);
  };

  useEffect(() => {
    setDisplayGroupedChart(
      groupedMetricsChartData !== undefined &&
        groupedMetricsChartData.length > 0,
    );
  }, [groupedMetricsChartData]);

  return (
    <div className="flex flex-col gap-y-4">
      <div className="flex flex-row justify-between px-6 pt-0">
        <div className="w-2/3 font-bold text-2xl">{selectedMetric?.label}</div>
        <div className="w-1/3 flex flex-row gap-x-1 justify-end">
          <div className="w-1/2">
            <Select
              options={metricsSelectables}
              placeholder="Seleccione una métrica"
              defaultValue={context.selectedMetric.value}
              onValueChange={onValueChangeHandler}
            />
          </div>
          <div className="w-1/2">
            <Select
              options={dimensionsSelectables}
              placeholder="Agrupar por"
              defaultValue={context.selectedGroupingDimension}
              onValueChange={onGroupingDimensionChangeHandler}
            />
          </div>
        </div>
      </div>
      <CardContent>
        {!displayGroupedChart && (
          <MetricsChart
            params={params}
            selectedMetric={selectedMetric}
            xAxisMinValue={dateRange?.from}
            xAxisMaxValue={dateRange?.to}
          />
        )}
        {displayGroupedChart && (
          <MetricsChartByDimension
            data={groupedMetricsChartData}
            xAxisMinValue={dateRange?.from}
            xAxisMaxValue={dateRange?.to}
            selectedMetric={selectedMetric}
          />
        )}
      </CardContent>
    </div>
  );
};

export default MetricsChartContainer;
